import React, { useState } from "react";
import PasswordStrengthMeter from "./PasswordStrengthMeter";
import ReactIsCapsLockActive from "@matsun/reactiscapslockactive";
import { ShowIcon, HideIcon } from "./ShowHideIcons";

const PasswordField = props => {
	const [focused, setFocused] = useState(false);

	return (
		<>
			<div className={`password-field-wrapper ${props.disableField ? "disabled" : ""} ${props.showStrengthMeter ? "mb-md" : ""}`}>
				<label className="label" htmlFor={props.id}>
					{props.label}
				</label>
				<div
					className={`
						input-field-wrapper
						${props.passwordsMatch ? "passwords-match" : ""}
						${props.disableField ? "disabled" : ""}
						`}
				>
					<input
						className={`password-field ${props.passwordsMatch ? "passwords-match" : ""}`}
						required
						autoComplete="new-password"
						name="password"
						type={props.showPassword ? "text" : "password"}
						id={props.id}
						minLength={props.minLength}
						onChange={e => props.onPasswordChange(e.target.value)}
						onFocus={() => setFocused(true)}
						onBlur={() => setFocused(false)}
						autoFocus={props.isFocused}
						disabled={props.disableField}
					/>
					<div
						className={`icon-container ${props.disableField ? "disabled" : ""} ${
							props.passwordsMatch ? "passwords-match" : ""
						}`}
						onClick={props.togglePasswordVisibility}
					>
						{props.showPassword ? (
							<ShowIcon disableField={props.disableField} passwordsMatch={props.passwordsMatch} />
						) : (
							<HideIcon disableField={props.disableField} passwordsMatch={props.passwordsMatch} />
						)}
						<span className="hide-show-label" aria-label={props.showPassword ? "Password visible" : "Password hidden"}>
							{props.showPassword ? "Hide" : "Show"}
						</span>
					</div>
					{props.showStrengthMeter && (
						<PasswordStrengthMeter
							score={props.score}
							password={props.password}
							passwordsMatch={props.passwordsMatch}
						/>
					)}
				</div>

				{focused && (
					<ReactIsCapsLockActive>
						{active => (active ? <span className="caps-lock-notification visible">Warning: Caps lock is on</span> : "")}
					</ReactIsCapsLockActive>
				)}
			</div>
		</>
	);
};

export default PasswordField;
